import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const CookiePopup = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('gamepulse_consent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  // Fonction pour l'accès gratuit (accepte les cookies publicitaires)
  const handleAcceptAll = () => {
    localStorage.setItem('gamepulse_consent', 'accepted');
    setIsVisible(false);
    window.location.reload(); // Recharge pour activer les pubs
  };

  // FONCTION CORRIGÉE POUR PAYPAL (ton code original conservé)
  const handleSubscribe = (plan) => {
    window.open("https://www.paypal.com/ncp/payment/FVS62NNGF7J8C", "_blank");
    console.log(`Souscription au plan : ${plan}`);
    // Exemple : redirection ou appel API PayPal
    // window.location.href = "https://paypal.com/...";
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-popup-overlay">
      <div className="cookie-popup">
        <h2>{t("cookie.title")}</h2>
        <p>{t("cookie.message")}</p>

        <div className="cookie-options">
          {/* OPTION PAYPAL PREMIUM - Conservée telle quelle */}
          <div className="cookie-option-card premium">
            <h3>{t("cookie.premium")}</h3>
            <p className="price">1.99$ <span className="duration">/ mois</span></p>
            <p className="description">{t("cookie.premium_description")}</p>
            <ul className="benefits">
              <li>{t("cookie.benefit_no_ads")}</li>
              <li>{t("cookie.benefit_priority")}</li>
              <li>{t("cookie.benefit_exclusive")}</li>
            </ul>
            <button onClick={() => handleSubscribe('premium')} className="btn-paypal">
              {t("cookie.subscribe_paypal")}
            </button>
          </div>

          {/* OPTION ACCÈS GRATUIT - Conservée telle quelle */}
          <div className="cookie-option-card highlighted">
            <h3>{t("cookie.free_access")}</h3>
            <p className="price">0$ <span className="duration">/ {t("cookie.always")}</span></p>
            <p className="description">{t("cookie.free_description")}</p>
            <button onClick={handleAcceptAll} className="btn-cookie-accept">
              {t("cookie.accept_and_access")}
            </button>
          </div>
        </div>

        <p className="cookie-footer-text">
          {t("cookie.change_mind")}{' '}
          <Link to="/privacy-policy">{t("cookie.preferences_link")}</Link>.
        </p>
      </div>
    </div>
  );
};

export default CookiePopup;